/**
 * Native predictive search.
 *
 * Vervangt de Algolia-datalaag: algolia-search-grid.js (373 KB),
 * search-modal.js (40 KB), search-autocomplete.js (24 KB),
 * search-product-handler.js (12 KB) en services-algolia-search.js (10 KB).
 *
 * TWEE BRONNEN
 *
 * 1. Sectierendering — /search?q=...&section_id=predictive-search-results
 *    De productkaartjes én de collectiechips. Levert HTML, dus letterlijk
 *    dezelfde component als op de collectiepagina, met de prijs uit Liquid.
 *
 * 2. Predictive Search API — /search/suggest.json
 *    Alleen de zoeksuggesties. Shopify levert die voorlopig alleen in het
 *    Engels; het blok verbergt zichzelf als de lijst leeg is.
 *
 * De positionering van de modal staat bewust in een apart bestand
 * (extenders-search-position.js): extenders-search-bar.js overschrijft de
 * inline top bij het openen, en daar moet apart op gereageerd worden.
 *
 * SHOPIFY ANALYTICS
 *
 * Shopify registreert zoekopdrachten wanneer iemand /search laadt. Onze
 * dropdown haalt data op via XHR en veel bezoekers klikken direct door naar
 * een product, dus die pageview komt er nooit. Daarom publiceren we zelf een
 * search_submitted-event bij daadwerkelijke intentie: enter, klik op een
 * resultaat, of klik op 'Alle resultaten'. Niet bij elke toetsaanslag — dat
 * zou het rapport vullen met halve woorden.
 *
 * Geen forced reflows: we schrijven één keer innerHTML en lezen geen
 * geometrie terug.
 */
(function () {
  'use strict';

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var SEARCH_URL = ROOT + 'search';
  var SUGGEST_URL = ROOT + 'search/suggest.json';
  var SECTION = 'predictive-search-results';

  var DEBOUNCE_MS = 200;
  var MIN_CHARS = 2;
  var RECENT_KEY = 'tam_recent_searches';
  var RECENT_MAX = 5;

  var input = document.querySelector('.search-bar__input, input[name="q"]');
  var modal = document.getElementById('search-modal');
  if (!input || !modal) return;

  var i18n = {
    resultsFor: modal.getAttribute('data-i18n-results-for') || 'Resultaten voor',
    noResults: modal.getAttribute('data-i18n-no-results') || 'Geen resultaten gevonden voor',
    collections: modal.getAttribute('data-i18n-collections') || 'Collecties'
  };

  var timer = null;
  var cardsController = null;
  var suggestController = null;
  var cardsCache = {};
  var suggestCache = {};
  var views = ['mobile', 'desktop'];
  var currentTerm = '';

  var initial = {};
  views.forEach(function (view) {
    var chips = document.getElementById(view + '-trending-collections');
    var head = document.getElementById(view + '-collections-header');
    var cards = document.getElementById(view + '-search-results');
    var cardsHead = document.getElementById(view + '-search-products-header');
    initial[view] = {
      chips: chips ? chips.innerHTML : '',
      chipsHeading: head ? head.textContent : '',
      cards: cards ? cards.innerHTML : '',
      cardsHeading: cardsHead ? cardsHead.textContent : ''
    };
  });

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function quoted(term) {
    return '\u201c' + term + '\u201d';
  }

  /* ---------- Shopify Analytics ---------- */

  function trackSearch(term) {
    if (!term) return;
    try {
      if (window.Shopify && window.Shopify.analytics &&
          typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish('search_submitted', {
          searchResult: { query: term }
        });
      }
    } catch (e) {
      /* Analytics mag nooit de zoekfunctie breken. */
    }
  }

  /* ---------- recente zoekopdrachten ---------- */

  function getRecent() {
    try { return JSON.parse(localStorage.getItem(RECENT_KEY)) || []; } catch (e) { return []; }
  }

  function addRecent(term) {
    if (!term) return;
    var list = getRecent().filter(function (t) { return t !== term; });
    list.unshift(term);
    try { localStorage.setItem(RECENT_KEY, JSON.stringify(list.slice(0, RECENT_MAX))); } catch (e) {}
  }

  function hideRecent() {
    views.forEach(function (view) {
      var section = document.getElementById(view + '-recent-searches-section');
      if (section) section.style.display = 'none';
    });
  }

  function renderRecent() {
    if (input.value.trim().length > 0) {
      hideRecent();
      return;
    }

    var list = getRecent();
    views.forEach(function (view) {
      var box = document.getElementById(view + '-recent-searches');
      var clear = document.getElementById(view + '-clear-recent');
      var section = document.getElementById(view + '-recent-searches-section');
      if (!box) return;

      if (!list.length) {
        box.innerHTML = '';
        if (clear) clear.style.display = 'none';
        if (section) section.style.display = 'none';
        return;
      }

      if (section) section.style.display = '';
      if (clear) clear.style.display = '';
      box.innerHTML = list.map(function (t) {
        return '<a href="' + SEARCH_URL + '?q=' + encodeURIComponent(t) +
          '&type=product" class="search-recent__item">' + esc(t) + '</a>';
      }).join('');
    });
  }

  views.forEach(function (view) {
    var clear = document.getElementById(view + '-clear-recent');
    if (!clear) return;
    clear.addEventListener('click', function () {
      try { localStorage.removeItem(RECENT_KEY); } catch (e) {}
      renderRecent();
    });
  });

  /* ---------- zoeksuggesties ---------- */

  function paintSuggestions(queries, term) {
    var lower = term.toLowerCase();
    var items = (queries || [])
      .filter(function (q) { return q.text && q.text.toLowerCase() !== lower; })
      .slice(0, 5);

    views.forEach(function (view) {
      var section = document.getElementById(view + '-suggestions-section');
      var box = document.getElementById(view + '-suggestions');
      if (!box || !section) return;

      if (!items.length) {
        section.style.display = 'none';
        box.innerHTML = '';
        return;
      }

      section.style.display = '';
      box.innerHTML = items.map(function (q) {
        var label = q.styled_text || esc(q.text);
        return '<a href="' + esc(q.url || (SEARCH_URL + '?q=' + encodeURIComponent(q.text) + '&type=product')) +
          '" class="search-suggestion">' + label + '</a>';
      }).join('');
    });
  }

  function fetchSuggest(term) {
    if (suggestCache[term]) { paintSuggestions(suggestCache[term], term); return; }
    if (suggestController) suggestController.abort();
    suggestController = new AbortController();

    var url = SUGGEST_URL +
      '?q=' + encodeURIComponent(term) +
      '&resources[type]=query' +
      '&resources[limit]=5';

    fetch(url, { signal: suggestController.signal })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (currentTerm !== term) return;
        var res = (data.resources && data.resources.results) || {};
        var queries = res.queries || [];
        suggestCache[term] = queries;
        paintSuggestions(queries, term);
      })
      .catch(function (e) {
        if (e.name !== 'AbortError') console.error('suggest', e);
      });
  }

  /* ---------- resultaten ---------- */

  function restoreInitial() {
    currentTerm = '';

    views.forEach(function (view) {
      var chips = document.getElementById(view + '-trending-collections');
      var chipsHead = document.getElementById(view + '-collections-header');
      var cards = document.getElementById(view + '-search-results');
      var cardsHead = document.getElementById(view + '-search-products-header');
      var cta = document.getElementById(view + '-search-cta');
      var sug = document.getElementById(view + '-suggestions-section');

      if (chips) chips.innerHTML = initial[view].chips;
      if (chipsHead) chipsHead.textContent = initial[view].chipsHeading;
      if (cards) cards.innerHTML = initial[view].cards;
      if (cardsHead) cardsHead.textContent = initial[view].cardsHeading;
      if (cta) cta.style.display = 'none';
      if (sug) sug.style.display = 'none';
    });

    renderRecent();
  }

  function bindResultTracking(box, term) {
    box.addEventListener('click', function (e) {
      if (e.target.closest('a')) trackSearch(term);
    }, { once: true });
  }

  function paint(html, term) {
    var wrap = document.createElement('div');
    wrap.innerHTML = html;

    var meta = wrap.querySelector('[data-results-count]');
    var cards = wrap.querySelector('[data-product-cards]');
    var chips = wrap.querySelector('[data-collection-chips]');

    var count = meta ? parseInt(meta.getAttribute('data-results-count'), 10) || 0 : 0;
    var url = meta ? meta.getAttribute('data-results-url') : SEARCH_URL;

    /* Tel alleen de anchors: product-button stuurt per kaartje ook één
       <link> en vier <script> mee. */
    var anchorCount = cards ? cards.querySelectorAll(':scope > a').length : 0;
    var hasCards = anchorCount > 0;
    var hasChips = chips && chips.children.length > 0;

    views.forEach(function (view) {
      var box = document.getElementById(view + '-search-results');
      var head = document.getElementById(view + '-search-products-header');
      var link = document.getElementById(view + '-search-products-link');
      var cta = document.getElementById(view + '-search-cta');

      if (link) link.href = url;
      if (!box) return;

      if (!hasCards) {
        if (head) head.textContent = i18n.noResults + ' ' + quoted(term);
        box.innerHTML = '';
        if (cta) cta.style.display = 'none';
        return;
      }

      if (head) head.textContent = i18n.resultsFor + ' ' + quoted(term);
      box.innerHTML = cards.innerHTML;
      bindResultTracking(box, term);

      /* Op desktop verbergt CSS alles vanaf het vijfde kaartje. */
      var visible = view === 'desktop' ? Math.min(4, anchorCount) : anchorCount;
      if (cta) cta.style.display = count > visible ? '' : 'none';
    });

    views.forEach(function (view) {
      var box = document.getElementById(view + '-trending-collections');
      var head = document.getElementById(view + '-collections-header');
      if (!box) return;

      if (hasChips) {
        box.innerHTML = chips.innerHTML;
        if (head) head.textContent = i18n.collections;
      } else {
        box.innerHTML = initial[view].chips;
        if (head) head.textContent = initial[view].chipsHeading;
      }
    });
  }

  function fetchCards(term) {
    if (cardsCache[term]) { paint(cardsCache[term], term); return; }
    if (cardsController) cardsController.abort();
    cardsController = new AbortController();

    var url = SEARCH_URL +
      '?q=' + encodeURIComponent(term) +
      '&type=product' +
      '&options[prefix]=last' +
      '&options[unavailable_products]=last' +
      '&section_id=' + SECTION;

    fetch(url, { signal: cardsController.signal })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        if (currentTerm !== term) return;
        cardsCache[term] = html;
        paint(html, term);
      })
      .catch(function (e) {
        if (e.name !== 'AbortError') console.error('predictive search', e);
      });
  }

  /* ---------- events ---------- */

  input.addEventListener('input', function () {
    var term = input.value.trim();
    clearTimeout(timer);

    if (term.length > 0) hideRecent();

    if (term.length < MIN_CHARS) {
      if (cardsController) cardsController.abort();
      if (suggestController) suggestController.abort();
      restoreInitial();
      return;
    }

    timer = setTimeout(function () {
      currentTerm = term;
      fetchCards(term);
      fetchSuggest(term);
    }, DEBOUNCE_MS);
  });

  input.addEventListener('focus', renderRecent);

  var form = input.closest('form');
  if (form) {
    form.addEventListener('submit', function () {
      var term = input.value.trim();
      addRecent(term);
      trackSearch(term);
    });
  }

  views.forEach(function (view) {
    var link = document.getElementById(view + '-search-products-link');
    if (!link) return;
    link.addEventListener('click', function () { trackSearch(input.value.trim()); });
  });

  renderRecent();
})();
